const menu = 
[
        {
            "id": 1,
            "idSearch": "/home",
            "titulo": "Home"
        },{
            "id": 2,
            "idSearch": "services",
            "titulo": "Services"
        },{
            "id": 3,
            "idSearch": "clients",
            "titulo": "Clients"
        },{
            "id": 4,
            "idSearch": "works",
            "titulo": "Works"
        },{
            "id": 5,
            "idSearch": "aboutus",
            "titulo": "Team"
        },{
            "id": 6,
            "idSearch": "contact",
            "titulo": "Contact"
        }
]
export default menu